import { IUISupplier } from '@bridebook/toolbox/src/types';
import { mapSupplierToAnalyticsRecord } from '@bridebook/web/lib/search/utils/map-suppliers/map-supplier-to-analytics-record';
import { SupplierAnalyticsShape } from '@bridebook/web/lib/search/utils/map-suppliers/shapes';

const mapSuppliersToAnalytics = (list: IUISupplier[]) =>
  list.map(mapSupplierToAnalyticsRecord(SupplierAnalyticsShape));

export default mapSuppliersToAnalytics;
